export const ICON_STYLE = {
  width: 24,
  height: 24,
  color: 'var(--typography500)',
}
